import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import MainContent from './components/MainContent';
import SubContent from './components/SubContent';

const InlineSection = ({ theme, icon, mainContent, subContent, className, classNames }) => (
    <div className={ classnames({
        [theme.inlineSection]: true,
        [className]: !!className,
        ...classNames,
    }) }
    >
        <MainContent { ...{ mainContent, icon, theme } } />
        <SubContent { ...{ subContent, theme } } />
    </div>
);

InlineSection.propTypes = {
    theme: PropTypes.shape({}),
    icon: PropTypes.shape({
        name: PropTypes.string,
        className: PropTypes.string,
    }),
    mainContent: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    subContent: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({}),
    ]),
    className: PropTypes.string,
    classNames: PropTypes.shape({}),
};

InlineSection.defaultProps = {
    icon: {
        name: null,
    },
    mainContent: '',
    subContent: '',
    className: null,
    classNames: {},
};

export default InlineSection;
